import { userUtils } from '@/utils/auth'
import { sessionStorageUtils } from '@/utils/sessionstorage'
import Vue from 'vue'
import Router from 'vue-router'
import activityRoutes from './modules/activity'
import authRoutes from './modules/auth'
import subordinateRoutes from './modules/subordinate'
import couponRoutes from './modules/coupon'
import centerQrcodeRoutes from './modules/center-qrcode'
import courseRoutes from './modules/course'
import errorRoutes from './modules/error'
import extraStyleRoutes from './modules/extra-style'
import galleryRoutes from './modules/gallery'
import lotteryRoutes from './modules/lottery'
import wxAppRoutes from './modules/wx-app'
import centerRoutes from './modules/center'
import sortRoutes from './modules/sort'
import cartRoutes from './modules/cart'
import bssRoutes from './modules/bss'
import Vconsole from 'vconsole'
import store from '../store/index'
// import subordinateRoutes from './modules/subordinate'
import { Toast } from 'vant'
Vue.use(Router)

const baseRoutes = [
  {
    path: '/',
    redirect: '/home-main'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home')
  },
  {
    path: '/home-main',
    name: 'home-main',
    component: () => import('@/views/home/home-main')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login')
  },
  {
    path: '/jdOrderDetail',
    name: 'jdOrderDetail',
    component: () => import('@/views/jd/order-detail')
  },
  {
    path: '/login2',
    name: 'login2',
    component: () => import('@/views/login/login2')
  },
  {
    path: '/register2',
    name: 'register2',
    component: () => import('@/views/login/register2')

  },
  {
    path: '/register3',
    name: 'register3',
    component: () => import('@/views/login/register3')

  },
  {
    path: '/cass-login',
    name: 'cassLogin',
    component: () => import('@/views/cass-login')
  },
  {
    path: '/sso/login',
    name: 'ssoLogin',
    component: () => import('@/views/sso-login/sso-login')
  },
  {
    path: '/sso/logout',
    name: 'ssoLogout',
    component: () => import('@/views/sso-login/sso-logout')
  },
  {
    path: '/ciam/login',
    name: 'ciamLogin',
    component: () => import('@/views/sso-login/ciam-login')
  },
  {
    path: '/ciam/logout',
    name: 'ciamLogout',
    component: () => import('@/views/sso-login/ciam-logout')
  },
  {
    path: '/sso/logout-loading',
    name: 'ssoLogoutLoading',
    component: () => import('@/views/sso-login/sso-logout-loading')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/home/search'),
    children: [{
      path: '',
      name: 'search-history',
      component: () => import('@/views/home/search/search-history')
    }, {
      path: 'searchResult',
      name: 'searchResult',
      component: () => import('@/views/home/search/search-result')
    }]
  },
  {
    path: '/notice/:id',
    name: 'notice',
    component: () => import('@/views/home/notice')
  }
]

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}

Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => err)
}

// errorRoutes 必须最后加入数组
const routes = baseRoutes.concat(galleryRoutes)
  .concat(courseRoutes)
  .concat(activityRoutes)
  .concat(lotteryRoutes)
  .concat(extraStyleRoutes)
  .concat(authRoutes)
  .concat(subordinateRoutes)
  .concat(couponRoutes)
  .concat(centerQrcodeRoutes)
  .concat(errorRoutes)
  .concat(wxAppRoutes)
  .concat(centerRoutes)
  .concat(sortRoutes)
  .concat(cartRoutes)
  .concat(bssRoutes)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ y: 0 })
})

router.beforeEach((to, from, next) => {
  console.log('33333')
  if (to.query && to.query.vconsole === 'show') {
    const vConsole = new Vconsole()
    console.log(typeof vConsole)
  }
  const needLogin = to.meta && to.meta.needLogin
  const limitMarket = to.meta && to.meta.limitMarket
  const needWxAuth = to.meta && to.meta.needWxAuth
  const needUserRole = to.meta && to.meta.needUserRole
  const clientInfo = userUtils.getClientInfo()
  // console.log(needLogin)
  // 活动登录限制
  if (needLogin) {
    if (clientInfo && clientInfo.isActivated === 0) {
      if (['activation_step_one',
        'activation_step_two',
        'activation_step_two_modification',
        'activation_step_three'].includes(to.name)) {
        next()
      } else {
        next('/activation_step_one')
      }
    } else if (!clientInfo) {
      console.log('4444')
      global.entryUrl = `${document.location.origin}/v2/login`
      router.push({ name: 'login2', params: { redirectUrl: to.name } })
      return
    }
  }
  // 活动市场限制
  if (clientInfo && limitMarket && limitMarket.length) {
    console.log('limitMarket')
    let hasMarketAuth
    limitMarket.forEach(market => {
      hasMarketAuth = market === clientInfo.marketName
    })
    if (!hasMarketAuth) {
      alert('该活动仅对指定用户开放')
      document.location = process.env.VUE_APP_EXTRA_SITE
    }
  }
  // 活动微信授权限制
  if (needWxAuth) {
    var uaInfo = navigator.userAgent.toLowerCase()
    var isWeixin = uaInfo.indexOf('micromessenger') !== -1
    sessionStorageUtils.set('isWeixin', isWeixin)
    const wxUserInfo = sessionStorageUtils.get('wxUserInfo')
    if (wxUserInfo && JSON.stringify(wxUserInfo) !== '{}') {
      console.log('has auth info')
      next()
    } else if (isWeixin) {
      console.log('need auth')
      next({
        name: 'wx-auth',
        query: {
          target: to.fullPath
        }
      })
    }
  }
  // 需要获取最新的用户角色类型
  if (needUserRole) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    })
    store.dispatch('updateUserRole').then(() => {
      Toast.clear()

      next()
    }).catch(() => { Toast.clear() })
  } else {
    next()
  }
  // next()
  // 修复调用jssdk异常bug
  // const u = navigator.userAgent
  // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  // if (to.name === 'lottery-home' && from.name === 'activity-collect-cards' && isIOS && location.href.indexOf('#reloaded') === -1) {
  //   next()
  //   location.href = process.env.VUE_APP_EXTRA_SITE + '/v2' + to.fullPath + '#reloaded'
  //   location.reload()
  // }
})

router.afterEach((to, from) => {
  if (!global.entryUrl) {
    global.entryUrl = location.href.split('#')[0]
    console.log('afterEach:', global.entryUrl)
  }
})

export default router
